// React
import React from "react";
// Libraries
import cn from "classnames";
import { isEmpty } from "lodash";
// Components
import { Icon } from "components";
// Resources
import fieldStyles from "./Field.module.scss";

interface FieldProps {
  children?: React.ReactNode;
  error?: string;
  helper?: string;
  infoIcon?: () => void;
  label?: string;
  labelFor: string;
}

export const Field = ({ children, error, helper, infoIcon, label, labelFor, ...props }: FieldProps): JSX.Element => (
  <div className={fieldStyles.field} {...props}>
    {label && (
      <label className={fieldStyles.field__label} htmlFor={labelFor}>
        {label}
        {infoIcon && (
          <button className={fieldStyles.field__icon} onClick={infoIcon}>
            <Icon colour="grey_dark" name="info" size="tiny" />
          </button>
        )}
      </label>
    )}
    <div className={cn(fieldStyles.field__input)}>{children}</div>
    {(error || helper) && (
      <p
        className={cn(fieldStyles.field__helper, {
          [fieldStyles["field__helper--error"]]: !isEmpty(error),
        })}
      >
        {error || helper}
      </p>
    )}
  </div>
);

Field.displayName = "Field";
